import "./Privacy.css";

const PrivacyPolicyProData = () => {
  return (
    <div style={{ padding: "10pt" }}>
      <h1 className="privacy-policy-title">
        Privacy Policy for Engage a Pro Providers
      </h1>

      <p>
        This Privacy Policy (“Policy”) explains how MentalFit, LLC (“MentalFit,”
        “we,” “us,” or “our”) collects, uses, and discloses information about
        third-party providers (“Provider,” “you,” “your”) who use the Engage a
        Pro feature of the MentalFit platform. This Policy is separate from our
        consumer-facing Privacy Policy and applies exclusively to Providers who
        offer services through the Engage a Pro interface.
      </p>

      <ol>
        <li>
          <h2>1. Scope of this Policy</h2>
          <p>
            This Policy applies only to the information we collect about
            Providers in their use of Engage a Pro. It does not apply to:
          </p>
          <ul style={{ paddingLeft: "15px", margin: 0 }}>
            <li className="custom-li">
              MentalFit users (i.e., clients receiving services)
            </li>
            <li className="custom-li">Visitors to our marketing website</li>
            <li className="custom-li">Employees or job applicants</li>
          </ul>

          <p>
            If you are a MentalFit user, please refer to our Main Privacy
            Policy.
          </p>
        </li>

        <li>
          <h2>2. Information We Collect from Providers</h2>
          <p>
            We collect the following information when you register or use the
            Engage a Pro platform:
          </p>

          <ul style={{ paddingLeft: "15px", margin: 0 }}>
            <li className="custom-li">
              Professional and contact details (e.g., name, phone number, email,
              license or certification)
            </li>
            <li className="custom-li">
              Biographical and practice information (e.g., areas of expertise,
              languages spoken)
            </li>
            <li className="custom-li">
              Platform usage data (e.g., login timestamps, device/browser info,
              session metrics)
            </li>
            <li className="custom-li">
              Authentication and account details (e.g., username, password,
              login logs)
            </li>
            <li className="custom-li">
              Optional content you submit (e.g., profile photo, introductory
              video)
            </li>
          </ul>

          <p>
            We do not collect or retain session notes, communications with
            clients, or any information you collect directly from users.
          </p>
        </li>

        <li>
          <h2>3. How We Use Provider Information</h2>
          <p>We use your information solely to:</p>

          <ul style={{ paddingLeft: "15px", margin: 0 }}>
            <li className="custom-li">
              Verify your identity and eligibility to participate on the
              platform
            </li>
            <li className="custom-li">
              Facilitate user discovery and profile visibility
            </li>
            <li className="custom-li">
              Communicate administrative and support-related updates
            </li>
            <li className="custom-li">
              Monitor platform performance and ensure system security
            </li>
            <li className="custom-li">
              Enforce our Terms of Use and Provider Agreement
            </li>
          </ul>

          <h3 style={{ position: "relative", paddingLeft: "34px" }}>
            <span
              style={{
                position: "absolute",
                left: 15,
                top: "0.6em", // vertically aligns the dot with the text
                height: "0.3em",
                width: "0.3em",
                backgroundColor: "black",
                borderRadius: "80%",
                display: "inline-block",
              }}
            ></span>
            Communications and Email Preferences
          </h3>

          <p style={{ position: "relative", paddingLeft: "55px" }}>
            <span
              style={{
                position: "absolute",
                left: 30,
                top: "0.6em",
                height: "0.5em",
                width: "0.5em",
                backgroundColor: "black",
                borderRadius: "50%",
                display: "inline-block",
              }}
            ></span>
            When you create a MentalFit account, we will send you certain email
            communications that are necessary to provide and support our
            services. These transactional or service-related emails may include,
            without limitation, welcome messages, appointment confirmations,
            reminders, password resets, account notifications, and other
            messages directly related to your use of MentalFit. We may also send
            occasional promotional or informational emails about new features,
            wellness content, events, or services that we believe may be
            relevant to you. You can opt out of receiving these non-essential
            promotional emails at any time by following the unsubscribe
            instructions in the email or by adjusting your preferences in your
            account settings. Please note that transactional or service-related
            emails are an essential part of your MentalFit experience and you
            cannot opt out of receiving them without deactivating your account.
            We will not include protected health information (PHI) in any email
            communications.
          </p>
        </li>

        <li>
          <h2>4. What MentalFit Does Not Do</h2>
          <p>To be clear, MentalFit:</p>
          <ul style={{ paddingLeft: "15px", margin: 0 }}>
            <li className="custom-li">
              Does not access or store private communications between Providers
              and users
            </li>
            <li className="custom-li">
              Does not collect, process, or store user health data shared during
              your sessions
            </li>
            <li className="custom-li">
              Does not participate in or influence your clinical or coaching
              decisions
            </li>
            <li className="custom-li">
              Does not act as a covered entity or business associate under HIPAA
              with respect to your practice
            </li>
            <li className="custom-li">
              Does not collect or process payment on your behalf
            </li>
          </ul>

          <p>
            You are fully responsible for the confidentiality and lawful
            handling of any user data you collect outside of the platform.
          </p>
        </li>

        <li>
          <h2>5. Provider Responsibilities</h2>
          <p>As a Provider using Engage a Pro, you agree to:</p>
          <ul style={{ paddingLeft: "15px", margin: 0 }}>
            <li className="custom-li">
              Comply with all applicable privacy, health, and data security laws
              (including HIPAA or state equivalents)
            </li>
            <li className="custom-li">
              Maintain accurate and truthful profile information
            </li>
            <li className="custom-li">
              Safeguard all information you obtain from users during sessions
            </li>
            <li className="custom-li">
              Promptly report any security breaches related to your use of the
              platform
            </li>
          </ul>

          <p>
            You acknowledge that MentalFit does not supervise or control your
            provision of services, nor does it monitor your interactions with
            users.
          </p>
        </li>

        <li>
          <h2>6. Information Sharing and Disclosure</h2>
          <p>
            MentalFit does not sell or share your personal information to third
            parties for advertising or commercial purposes. We may disclose your
            information:
          </p>
          <ul style={{ paddingLeft: "15px", margin: 0 }}>
            <li className="custom-li">To users via your public profile</li>
            <li className="custom-li">
              To service providers assisting with platform operations (under
              confidentiality agreements)
            </li>
            <li className="custom-li">
              When legally required (e.g., subpoenas, investigations)
            </li>
            <li className="custom-li">
              To protect the rights or safety of MentalFit, its users, or the
              public
            </li>
          </ul>
        </li>

        <li>
          <h2>7. Security and Data Retention</h2>
          <p>
            We implement appropriate safeguards to protect the limited Provider
            data we collect (e.g., account credentials, login metadata).
            However, you are independently responsible for protecting any user
            information you gather or store during your services.
          </p>
          <p>
            We retain your Provider data only as long as necessary to operate
            the platform and fulfill legal requirements.
          </p>
        </li>

        <li>
          <h2>8. Clarification of Relationship</h2>
          <p>
            Your use of Engage a Pro does not create an employee, contractor, or
            agency relationship between you and MentalFit. MentalFit provides a
            technology platform for connecting users with independent Providers.
            MentalFit does not direct, control, or supervise the wellness
            services you offer, and does not establish a joint data controller
            or co-provider relationship. You are solely responsible for your
            interactions with users and your own legal and ethical obligations.
          </p>
        </li>

        <li>
          <h2>9. Updates to This Policy</h2>
          <p>
            We may modify this Policy from time to time. We will notify you of
            material changes via email or dashboard alerts. Continued use of the
            Engage a Pro platform after changes are posted constitutes your
            acceptance of the revised Policy.
          </p>
        </li>

        <li>
          <h2>10. Provider Consent and Acknowledgment</h2>
          <p>
            By registering for or using the Engage a Pro platform, you
            acknowledge that you have read, understood, and agree to be bound by
            this Privacy Policy and any applicable Provider Terms.
          </p>
        </li>

        <li>
          <h2>11. Audit & Compliance Cooperation Clause</h2>
          <p>
            Providers agree to reasonably cooperate with MentalFit in the event
            of a user data concern, legal request, or system audit related to
            platform use.
          </p>
        </li>

        <li>
          <h2>12. State-Specific Compliance (e.g., Colorado Privacy Act)</h2>
          <p>
            MentalFit is headquartered in Colorado and processes personal
            information in accordance with the Colorado Privacy Act (CPA).
            Providers who serve Colorado residents are expected to ensure
            compliance with applicable state-level data protection laws.
          </p>
        </li>

        <li>
          <h2>13. Provider-User Data Handling Disclosure (Optional)</h2>
          <p>
            Users are encouraged to request and review their provider’s own
            privacy practices, including how session records or contact
            information are stored outside of MentalFit’s platform.
          </p>
        </li>

        <li>
          <h2>14. Minors</h2>
          <p>
            Online components of our Services are not directed to children under
            the age of eighteen (18), and we do not knowingly collect Personal
            Information via online Services from children under the age of 18.
            If you think that we have collected Personal Information via an
            online Service from a child under the age of 18, please contact us.
          </p>
          <p>
            The Service is not intended to be accessed by minors under the age
            of eighteen (18). If we discover that an individual under 18 has
            provided us with Personal Information, we will delete the Personal
            Information to the extent required by the Children’s Online Privacy
            Protection Act.
          </p>
        </li>

        <li>
          <h2>15. California Privacy Rights</h2>
          <p>
            California residents may exercise certain CCPA privacy rights with
            respect to their Personal Information:
          </p>
          <ul style={{ paddingLeft: "10px", margin: 0 }}>
            <li className="custom-li">
              <strong>Notice:</strong> The right to be notified of what
              categories of Personal Information will be collected at or before
              the point of collection and the purpose for which they will be
              used and shared.
            </li>
            <li className="custom-li">
              <strong>Right to Know/Access:</strong> You have the right to
              request that we disclose to you what Personal Information we
              collect, use, disclose, and sell about you, including: The
              categories of Personal Information we have collected about you in
              the preceding 12 months; The categories of sources from which the
              Personal Information is collected; The business or commercial
              purpose for collecting or selling the Personal Information; The
              categories of Personal information, if any, that we disclosed for
              a business purpose or sold to third parties in the preceding 12
              months; and The categories of third parties to whom the
              information was disclosed or sold.
            </li>
            <li className="custom-li">
              <strong>Data Portability:</strong> The right to receive the
              Personal Information you have previously provided to us.
            </li>
            <li className="custom-li">
              <strong>Right to Delete:</strong> You have the right to request
              that we delete the Personal Information we collect about you.
            </li>
            <li className="custom-li">
              <strong>To Opt-Out:</strong> You have the right to opt-out of the
              sale of your Personal Information to third parties. Currently, we
              do not sell your Personal Information. If you have any questions,
              please reach out to us by using the contact information below.
            </li>
            <li className="custom-li">
              <strong>Right to Non-Discrimination:</strong> You have the right
              to not receive discriminatory treatment by us if you exercise any
              of the rights conferred to you by the CCPA.
            </li>
          </ul>

          <h3>How to Exercise Your California Rights</h3>
          <p>
            If you are a California resident and would like to exercise any of
            your rights listed above, please contact us at
            getstarted@mentalfitlife.com. You may also designate an authorized
            agent to make a request to exercise your rights on your behalf.
          </p>
          <p>
            When contacting us to exercise your rights, please adhere to the
            following guidelines:
          </p>
          <ul style={{ paddingLeft: "10px", margin: 0 }}>
            <li className="custom-li">
              <strong>Tell Us Which Right You Are Exercising:</strong> Specify
              which right you want to exercise and the Personal Information to
              which your request relates. If you are acting as an authorized
              agent, clearly indicate this fact and your authority to act.
            </li>
            <li className="custom-li">
              <strong>Help Us Verify Your Identity:</strong> Provide enough
              information to verify your identity. We may request additional
              information if we cannot initially verify your identity.
            </li>
            <li className="custom-li">
              <strong>Direct Our Response Delivery:</strong> Inform us of your
              preferred delivery mechanism (e.g., email, mail, or through your
              account).
            </li>
          </ul>

          <p>
            You do not need to create an account with us to make a request to
            exercise your rights.
          </p>
          <h3>How We Respond to Your Requests</h3>
          <p>
            We will respond to your Valid Request within 45 days of receipt. We
            will not charge a fee unless your request is excessive, repetitive,
            or manifestly unfounded, in which case we will notify you and
            explain the decision.
          </p>
          <p>
            Submit a Valid Request by emailing us at:
            getstarted@mentalfitlife.com.
          </p>
          <h3>Non-Discrimination</h3>
          <p>
            We will not discriminate against you for exercising your CCPA
            rights. We will not deny services, charge different prices, or
            provide lower quality services for exercising these rights, though
            we may offer different tiers as allowed by law.
          </p>
          <h3>Contacting the California Attorney General</h3>
          <p>
            You may lodge a complaint with the California Attorney General’s
            office at
            https://oag.ca.gov/contact/consumer-complaint-against-business-or-company
            or by telephone at (916) 210-6276. We encourage you to contact us
            first to resolve any complaints.
          </p>
        </li>

        <li>
          <h2>16. Business Transfers</h2>
          <p>
            If we are involved in a merger, acquisition, corporate
            reorganization, or sale of assets, your information may be
            transferred as part of that transaction. We will take reasonable
            steps to ensure that your personal information is treated in a
            manner consistent with this Privacy Policy and applicable law, and
            we will provide notice to you before your personal information is
            transferred and becomes subject to a different privacy policy.
          </p>
        </li>

        <li>
          <h2>17. Contact Us</h2>
          <p>For questions about this Policy, contact:</p>
          <p>
            <strong>MentalFit, LLC</strong>
            <br />
            Email: getstarted@mentalfitlife.com
          </p>
        </li>
      </ol>
    </div>
  );
};

export default PrivacyPolicyProData;
